






































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import DateMethods from '@/mixins/DateMethods.vue';
import { dateFormat, dateTimeFormat } from '@/ts/DefaultTableConfigs';
import FeedItemData from '@/ts/FeedItemData';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';

@Component({
    components: {
        FlexibleTable,
    },
})
export default class NotificationList extends Mixins(DateMethods) {
    public tableEntity: string = 'NotificationList';
    public notificationDropdown: boolean = false;
    public notificationDropdownIndex: number = -1;

    constructor() {
        super();
    }

    get columns(): any {
        return [
            { name: 'id', label: this.$t('general.id', 'ID'), align: 'left', field: 'id', sortable: true, required: true },
            { name: 'title', label: this.$t('general.title-uppercase', 'Title'), align: 'left', field: 'title', sortable: true, required: false },
            { name: 'author', label: this.$t('general.creator', 'Creator'), align: 'left', sortable: true, required: false, filter: false,
                field: (row: any) => (row.author) ? this.getAuthorFullName(row.author) : '',
            },
            { name: 'publishedAt', label: this.$t('general.scheduled-date', 'Scheduled date'), align: 'left', sortable: true, filterType: 'date',
                // field: (row: any) => this.$moment(row.publishedAt).isValid() ? this.$moment.utc(row.publishedAt).format(dateTimeFormat) : null,
                field: (row: any) => this.getLocalDateTimeString(row.publishedAt),
                sort: (a: any, b: any) => {
                    const aTimestamp = a !== '' ? this.$moment(a, dateFormat).valueOf() : 0;
                    const bTimestamp = b !== '' ? this.$moment(b, dateFormat).valueOf() : 0;
                    return aTimestamp - bTimestamp;
                },
            },
            { name: 'createdAt', label: this.$t('general.creation-date', 'Creation date'), align: 'left', field: 'createdAt', sortable: true, filterType: 'date',
                sort: (a: any, b: any) => {
                    const aTimestamp = a !== '' ? this.$moment(a, dateFormat).valueOf() : 0;
                    const bTimestamp = b !== '' ? this.$moment(b, dateFormat).valueOf() : 0;
                    return aTimestamp - bTimestamp;
                },
            },
            { name: 'channel', label: this.$t('general.channel', 'Channel'), align: 'left', sortable: true, required: false, filter: false,
                field: (row: any) => {
                    return this.returnChannelCapitalize(row.channel);
                },
            },
            { name: 'projects', label: this.$t('general.projects', 'Projects'), align: 'left', sortable: true, required: false, 
                field: 'projectNames', classes: 'hoc-notification-table-column-xs', filterType: 'array',
            },
            { name: 'unitGroups', label: this.$t('general.unit-groups', 'Unit Groups'), align: 'left', sortable: true, required: false,
                field: 'unitGroupNames', classes: 'hoc-notification-table-column-xs', filterType: 'array',
            },
            { name: 'comments', label: this.$t('general.comments', 'Comments'), align: 'left', sortable: true, required: false, filter: false,
                sort: (a: string | number, b: string | number) => {
                    const aComments = typeof a === 'string' ? 0 : a;
                    const bComments = typeof b === 'string' ? 0 : b;

                    return aComments - bComments;
                },
                field: (row: FeedItemData) => {
                    return row.comments > 0 ? row.comments : this.$t('general.no-comments', 'No comments');
                },
            },
        ];
    }

    get defaultTableConfig(): TableViewConfig {
        return {
            visibleColumns: [
                'id',
                'title',
                'author',
                'createdAt',
                'channel',
                'projects',
            ],
        };
    }

    get getNotificationData(): FeedItemData[] {
        const broadcasts = this.$store.getters['Notifications/allNotifications'];

        return broadcasts.filter((broadcast: any) => broadcast.persisted);
    }

    public deleteEvent(id: number, title: string) {
        this.closeDropDown();

        this.$store.commit(Mutations.SET_CONFIRM_POPUP_DATA, {
            confirmAction: 'Notifications/DELETE_NOTIFICATION',
            confirmActionData: { id },
            confirmQuestionText: this.$t('confirmation.are-you-sure-you-want-to-delete-this-broadcast', 'Are you sure you want to delete this broadcast?'),
            confirmInfoText: `${title}`,
            confirmButton: this.$t('forms.delete', 'Delete'),
            confirmButtonClass: 'hococo-close-form-btn',
        });
    }

    public editBroadcastFlyout(id: number) {
        this.slideInForm('edit-notification', id);
    }

    public slideInForm(formKey: string, itemId: any) {
        this.closeDropDown();
        this.$store.commit(Mutations.UPDATE_ACTIVE_NOTIFICATION, itemId);
        this.$store.commit(Mutations.EDIT_ACTIVE_NOTIFICATION);
        this.$store.commit(Mutations.SHOW_EDIT_NOTIFICATION_FORM, formKey);
    }

    public toggleNotificationDropdown(index: number) {
        if (index === this.notificationDropdownIndex) {
            this.closeDropDown();
        } else {
            this.notificationDropdown = this.notificationDropdownIndex !== -1 ? true : !this.notificationDropdown;
            this.notificationDropdownIndex = index;
        }
    }

    public returnChannelCapitalize(channel: string) {
        let translatedChannelName;

        switch (channel) {
            case 'email':
                translatedChannelName = this.$t('forms.email-only', 'Email only');
                break;
            case 'sms':
                translatedChannelName = this.$t('forms.sms', 'Sms');
                break;
            default:
                translatedChannelName = this.$t('forms.app-notification', 'App - notification');
        }

        return translatedChannelName.charAt(0).toUpperCase() + translatedChannelName.slice(1);
    }

    public getAuthorFullName(author: any) {
        return typeof author.person === 'undefined' ? author.name : `${author.person.first_name} ${author.person.family_name}`;
    }

    public closeDropDown() {
        this.notificationDropdown = false;
        this.notificationDropdownIndex = -1;
    }

    public beforeDestroy() {
        window.removeEventListener('click', this.closeDropDown);
    }

    public created() {
        window.addEventListener('click', this.closeDropDown);
    }
}
